<form [formGroup]="getForm()" class="form-container ng" novalidate
      (ngSubmit)="save(getForm().value)">
  <h1>{{'Please enter the new password' | translate}}</h1>

  <div class="form-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-between center">
    <label class="control-label" fxFlex="40">
      {{'Password' | translate}}
    </label>
    <div class="input-container" fxFlex="60" fxLayout="column">
      <input
        id="password"
        type="password"
        class="form-control"
        placeholder="Ex. 12abcDEF"
        formControlName="password">
      <div fxLayout="column" class="feedback-wrapper"
           *ngIf="getForm().controls['password'].errors && (getForm().controls['password'].dirty || getForm().controls['password'].touched)">
        <small fxFlex="100" [hidden]="!getForm().controls['password'].errors.required" class="feedback">
          {{'Required' | translate}}.
        </small>
        <small fxFlex="100" [hidden]="!getForm().controls['password'].errors.minlength" class="feedback">
          {{'Should be at least 8 characters long' | translate}}.
        </small>
        <small fxFlex="100" [hidden]="!getForm().controls['password'].errors.pattern" class="feedback">
          {{'Must contain at least 1 uppercase [A-Z], 1 lowercase [a-z] and 1 character[0-9]' | translate}}.
        </small>
      </div>
    </div>
  </div>

  <div class="form-group" fxLayout fxLayout.xs="column" fxLayoutAlign="space-between center">
    <label class="control-label" fxFlex="40">
      {{'Confirm Password' | translate}}
    </label>
    <div class="input-container" fxFlex="60" fxLayout="column">
      <input
        id="repeatPassword"
        type="password"
        class="form-control"
        formControlName="repeatPassword">
      <div fxLayout="column" class="feedback-wrapper"
           *ngIf="getForm().errors && (getForm().controls['repeatPassword'].dirty || getForm().controls['repeatPassword'].touched) && getForm().errors.passwordsDoNotMatch">
        <small class="feedback">
          {{'Passwords do not match' | translate}}.
        </small>
      </div>
      <div fxLayout="column" class="feedback-wrapper"
           *ngIf="getForm().controls['repeatPassword'].errors && (getForm().controls['repeatPassword'].dirty || getForm().controls['repeatPassword'].touched)">
        <small [hidden]="!getForm().controls['repeatPassword'].errors.required" class="feedback">
          {{'Required' | translate}}.
        </small>
      </div>
    </div>
  </div>

  <div class="form-group" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center">
    <button id="resetPassword" type="submit" class="btn btn-primary" [disabled]="!getForm().valid">
      {{'reset password' | translate}}
    </button>
  </div>

</form>

<hr>
